import DocumentHeaderView from "./DocumentHeaderView";

export default DocumentHeaderView;



// WEBPACK FOOTER //
// ./src/components/DocumentV2/DocumentHeaderView/index.js